// hooks/useIndicadores.js
import { useState, useEffect, useMemo } from "react"
import CalcService from "src/services/calc-service"

export function useIndicadores() {
  const [options, setOptions] = useState([])
  const calcService = useMemo(() => new CalcService(), [])

  useEffect(() => {
    let mounted = true

    const fetchIndicadores = async () => {
      try {
        const result = await calcService.recuperaIndicador()

        // Garantir que seja uma lista de strings
        const optionsAsStrings = result.map(item => {
          if (item && typeof item === "object") {
            return item.indicador ?? JSON.stringify(item)
          }
          return String(item)
        })

        if (mounted) setOptions(optionsAsStrings)
      } catch (err) {
        console.error("Erro ao carregar Indicadores:", err)
      }
    }

    fetchIndicadores()
    return () => { mounted = false }
  }, [calcService])

  return options
}
